import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { updateTeamRole } from './types';

import { requestUpdateTeamRoleSuccess, requestUpdateTeamRoleFailure } from './actions';

const logger = new Logger('Saga:Team:UpdateRole');

export function* requestUpdateTeamRoleReducer(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.teams.update_role', { userId: action.userId }),
      { role: action.role },
    );

    yield put(requestUpdateTeamRoleSuccess(action.userId, response.data));
  } catch (error) {
    logger.error('Failed to update team role with the following error', error);
    yield put(requestUpdateTeamRoleFailure(action.userId, error));
  }
}

export default function* updateRoleSaga() {
  return yield all([takeLatest(updateTeamRole.request, requestUpdateTeamRoleReducer)]);
}
